export default __webpack_public_path__ + "static/staff02-f6c85a8a17c9d3d75783f081b4411d31.png";